import React, { useState } from 'react';
import { Checkbox, Modal } from '@material-ui/core';
import { AiFillCloseSquare } from 'react-icons/ai';
import * as S from './styles';
import estagiosPedido from '../../../interfaces/estagiosPedido';
import { foundEstagio } from '../../../utils/estagiosPedidos';
import { useMonitor } from '../../../hooks/newMonitor';
import Button from '../../../newComponents/Button';

interface ModalFilterProps {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  filter: number[];
  handleInsternshipFilter: (insternship: number) => void;
}

const ModalFilter: React.FC<ModalFilterProps> = (props) => {
  const { setModalIsOpen } = props;

  const { filter, setFilter } = useMonitor();

  const [insternshipFilter, setInsternshipFilter] = useState<number[]>(
    filter.insternship,
  );

  const handleInsternshipFilter = (insternship: number): void => {
    if (insternshipFilter.includes(insternship)) {
      setInsternshipFilter((oldState) =>
        oldState.filter((n) => n !== insternship),
      );
    } else {
      setInsternshipFilter((oldState) => [...oldState, insternship]);
    }
  };

  const handleSaveNewInsternship = (): void => {
    setFilter((oldState) => ({ ...oldState, insternship: insternshipFilter }));
    setModalIsOpen(false);
  };

  return (
    <Modal
      open
      onClose={() => {
        setModalIsOpen(false);
      }}
      closeAfterTransition
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <S.Container>
        <AiFillCloseSquare
          size={32}
          className="close"
          onClick={() => setModalIsOpen(false)}
        />
        <h1>Filtro Avançado</h1>

        <div className="checkbox">
          {Object.values(estagiosPedido).filter(n => (
            n !== 0 && n !== 7 && n !== 8 && n !== 10
          )).map((n: number) => (
            <div
              key={n}
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Checkbox
                style={{ color: '#329bfc' }}
                checked={insternshipFilter.includes(n)}
                onChange={() => handleInsternshipFilter(n)}
              />
              <p>{foundEstagio(n as any).significado}</p>
            </div>
          ))}
        </div>

        <Button onClick={handleSaveNewInsternship}>Salvar</Button>
      </S.Container>
    </Modal>
  );
};

export default ModalFilter;
